module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-700.80f10bd3.woff";